import { BaseApiService } from '@/shared/api/BaseApiService';

export interface Operatory {
  id: string;
  organizationId: string;
  clinicId: string;
  name: string;
  type: string;
  bufferMinutes: number;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateOperatoryInput {
  name: string;
  type?: 'general' | 'surgical' | 'hygiene' | 'pediatric' | 'imaging';
  bufferMinutes?: number;
  sortOrder?: number;
}

export interface UpdateOperatoryInput {
  name?: string;
  type?: 'general' | 'surgical' | 'hygiene' | 'pediatric' | 'imaging';
  bufferMinutes?: number;
  sortOrder?: number;
  isActive?: boolean;
}

export class OperatoriesService extends BaseApiService {
  protected resourcePath = 'operatories';

  async list(active?: boolean, type?: string): Promise<Operatory[]> {
    return this.get('', { params: { active, type } });
  }

  async getById(id: string): Promise<Operatory> {
    return this.get(`/${id}`);
  }

  async create(input: CreateOperatoryInput): Promise<Operatory> {
    return this.post('', input);
  }

  async update(id: string, input: UpdateOperatoryInput): Promise<Operatory> {
    return this.put(`/${id}`, input);
  }

  async deactivate(id: string): Promise<void> {
    return this.delete(`/${id}`);
  }
}

export const operatoriesService = new OperatoriesService();
